/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Job_Archived_SuccessInputs */



/**
* | output |
* | --- |
* | "AD job archived successfully." |
*
* @param {Ad_Job_Archived_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_job_archived_success = /** @type {((inputs?: Ad_Job_Archived_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Job_Archived_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tâche AD archivée avec succès.")
	if (locale === "de") return /** @type {LocalizedString} */ ("AD-Auftrag erfolgreich archiviert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Processo AD archiviato correttamente.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Задание Active Directory успешно завершено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tarea de AD archivada correctamente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AD作业已成功归档。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ADジョブは正常にアーカイブされました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विज्ञापन कार्य सफलतापूर्वक संग्रहित हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tarefa do AD arquivada com sucesso.")
	return /** @type {LocalizedString} */ ("AD job archived successfully.")
});